module.exports = __webpack_public_path__ + "static/media/footer-linkedin.52573d53.svg";